import { statusStyles, amountModeStyles } from '../css/revenueItems.styles';

export const REVENUE_ITEMS_PAGE_SIZE = 10;

export const formatDateTime = (value) => {
  if (!value) return '-';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year}  ${hour}:${minute}`;
};

/** Date part only — same order as formatDateTime (DD/MM/YYYY). */
export const formatDateOnly = (value) => {
  const formatted = formatDateTime(value);
  if (formatted === '-') return '-';
  return formatted.split('  ')[0];
};

export const formatRevenueType = (value) => {
  if (value === 'service_revenue') return 'Service';
  if (value === 'product_revenue') return 'Product';
  return value || '-';
};

export const formatPaymentRequestAmountMode = (value) => {
  if (value === 'flexible') return 'Flexible';
  return 'Fixed';
};

export const getAmountModeMeta = (value) =>
  amountModeStyles[value === 'flexible' ? 'flexible' : 'fixed'] || {
    label: formatPaymentRequestAmountMode(value),
    color: '#6b7280',
    bgColor: 'rgba(107, 114, 128, 0.15)',
  };

export const formatPaymentRequestAmount = (item) => {
  const currency = item?.currency || 'USDT';
  const amount = item?.amount;
  if (amount != null && String(amount).trim() !== '') {
    return `${amount} ${currency}`;
  }
  return '—';
};

export const formatSourceType = (value) => {
  if (value === 'payment_request') return 'Payment request';
  if (value === 'manual') return 'Manual';
  if (value === 'import') return 'Import';
  return value || '-';
};

export const getStatusMeta = (value) =>
  statusStyles[value] || {
    label: value || '-',
    color: '#6b7280',
    bgColor: 'rgba(107, 114, 128, 0.15)',
  };

export const buildPaginationItems = (currentPage, totalPages) => {
  if (totalPages <= 5) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 3) {
    return [1, 2, 3, '...', totalPages];
  }

  if (currentPage >= totalPages - 2) {
    return [1, '...', totalPages - 2, totalPages - 1, totalPages];
  }

  return [1, '...', currentPage, '...', totalPages];
};
